import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import BottomNav from './BottomNav';
import SiteSetupWizard from './site-setup/SiteSetupWizard';
import CcmLicenseBanner from './CcmLicenseBanner';
import OrgLicenseBanner from './OrgLicenseBanner';
import TutorialOverlay from './tutorials/TutorialOverlay';
import useAuthStore from '../stores/authStore';

const Layout = () => {
  // Remount the routed page when the tenant changes so every page
  // refetches its data cleanly. Without this, pages that don't watch
  // tenantVersion keep showing data from the previous tenant until
  // the user hard-refreshes.
  const { tenantVersion, currentTenant } = useAuthStore();
  const outletKey = `${currentTenant?.id || 'none'}-${tenantVersion}`;

  return (
    <div className="app-layout">
      {/* Opaque band owning the top safe-area inset. Rendered as a sibling of
          .main-content (NOT inside it) so it stays viewport-pinned on iOS: a
          fixed element inside a touch-scroll container scrolls with it. */}
      <div className="pwa-safe-area-band" aria-hidden="true" />
      <Sidebar />
      <main className="main-content">
        <OrgLicenseBanner />
        <CcmLicenseBanner />
        <Outlet key={outletKey} />
      </main>
      <BottomNav />
      <SiteSetupWizard />
      <TutorialOverlay />
    </div>
  );
};

export default Layout;
